(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('choicePossRules', {
        templateUrl: 'views/components/views/choicePossRules/choicePossRules.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'choicePossRulesService', 'choicePossRulesRunService', 'typeaheadService', 'rememberService', function ($stateParams, stateService, utilityService, choicePossRulesService, choicePossRulesRunService, typeaheadService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            let variableNames = {
                choice_prod_id: '',
                model_id: '',
                prod_id: '',
                furniturefabrics_id: '',
                prod_id_choosed: ''
            };

            vm.model = {
                productIdButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => gotoProduct() }
                ],
                modelButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('models') }
                ],
                modelButtonsGoto: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('model_id') },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('models') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('modelmenu', { model_id: vm.model.setting.model_id }) }
                ],
                productNameSelectButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.onTypeaheadClear('prod_name') }
                ],
                fabricsButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('furniturefabricss') }
                ],
                fabricsButtonsGoto: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('furniturefabrics_id') },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('furniturefabricss') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('furniturefabrics', { furniturefabrics_id: vm.model.setting.furniturefabrics_id }) }
                ],
                chosenProductButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('prod_id_choosed') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => gotoChosenProduct() }
                ],
                setting: {},
                selectListProductChoices: [],
                selectListModels: [],
                selectListFurnitureFabrics: [],
                selectListChosenProducts: [],
                selectListProductNames: [],
                itemsListRules: [],
                refreshing: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALLS

            async function retrieveNumberOfFurnitureFabrics() {
                if (vm.model.setting.choice_prod_id?.trim()) {
                    return vm.model.setting.nbr_of_furniturefabrics = (await choicePossRulesService.changeChoiceProductId({ choice_prod_id: vm.model.setting.choice_prod_id }))[0].nbr_of_furniturefabrics;
                }
            }

            async function loadFurnitureFabrics() {
                if (vm.model.setting.choice_prod_id && vm.model.setting.nbr_of_furniturefabrics > 0) {
                    return vm.model.selectListFurnitureFabrics = await choicePossRulesService.listFurnitureFabrics({
                        add_all: '1',
                        choice_prod_id: vm.model.setting.choice_prod_id
                    });
                }
            }

            async function retrieveNumberOfProducts() {
                if (vm.model.setting.model_id?.trim()) {
                    vm.model.setting.nbr_of_products = (await choicePossRulesService.changeModelId(vm.model.setting))[0].nbr_of_products;
                    return loadProductNames();
                }
            }

            async function loadChosenProducts() {
                if (vm.model.setting.choice_prod_id && vm.model.setting.furniturefabrics_id) {
                    return vm.model.selectListChosenProducts = await choicePossRulesService.listChosenProducts(vm.model.setting);
                }
            }

            async function loadProductNames() {
                if (vm.model.setting.model_id?.trim() && vm.model.setting.nbr_of_products < 200) {
                    return vm.model.selectListProductNames = await choicePossRulesService.listProductNames(vm.model.setting);
                }
            }

            async function loadProductChoices() {
                return vm.model.selectListProductChoices = await choicePossRulesRunService.listProductChoices();
            }

            async function loadModels() {
                return vm.model.selectListModels = await choicePossRulesRunService.listModels({
                    add_all: '1',
                    show_inactive: '0'
                });
            }

            async function loadRules() {
                if (vm.model.setting.choice_prod_id && vm.model.setting.choice_prod_id !== '0' && vm.model.setting.model_id && vm.model.setting.model_id !== '0') {
                    vm.model.itemsListRules = [];

                    return choicePossRulesService.listRules(vm.model.setting)
                        .then((list) => vm.model.itemsListRules = list)
                        .finally(() => vm.model.refreshing = false);
                }
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'choice_prod_id':
                    case 'model_id':
                    case 'prod_id':
                    case 'furniturefabrics_id':
                    case 'prod_id_choosed':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region MULTI CLEAR FUNCTION

            function clear(id) {
                switch (id) {
                    case 'model_id':
                        vm.model.setting.model_id = 'ALL';

                        if (vm.model.setting.model_id === 'ALL') {
                            rememberFunc('model_id');
                            retrieveNumberOfProducts();
                            loadRules();
                            vm.onTypeaheadClear('prod_name');
                        }
                        break;
                    case 'furniturefabrics_id':
                        vm.model.setting.furniturefabrics_id = 'ALL';
                        vm.model.setting.prod_id_choosed = '';

                        if (vm.model.setting.furniturefabrics_id === 'ALL') {
                            rememberFunc('furniturefabrics_id');
                            loadChosenProducts();
                            loadRules();
                        }

                        if (vm.model.setting.prod_id_choosed === '') rememberFunc('prod_id_choosed');
                        break;
                    case 'prod_id_choosed':
                        vm.model.setting.prod_id_choosed = '';

                        if (vm.model.setting.prod_id_choosed === '') {
                            rememberFunc('prod_id_choosed');
                            loadRules();
                        }
                        break;
                    default:
                        break;
                }
            }

            // #endregion MULTI CLEAR FUNCTION

            // #region DIRECTION FUNCTIONS

            function gotoProduct() {
                if (vm.model.setting.prod_id) {
                    choicePossRulesService.getProdKeyno({ prod_id: vm.model.setting.prod_id }).then((response) => {
                        if (response?.[0].prod_keyno) stateService.go('product', { prod_id: response[0].prod_keyno });
                    });
                }
            }

            function gotoChosenProduct() {
                if (vm.model.setting.prod_id_choosed?.trim()) {
                    choicePossRulesService.getProdKeyno({ prod_id: vm.model.setting.prod_id_choosed }).then((response) => {
                        if (response?.[0].prod_keyno) stateService.go('product', { prod_id: response[0].prod_keyno });
                    });
                }
            }

            // #endregion DIRECTION FUNCTIONS

            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            vm.typeaheadSearch = function (value, id) {
                switch (id) {
                    case 'prod_name':
                        vm.model.setting[id] = value;

                        return typeaheadService.searchProduct({
                            prod_name: vm.model.setting[id] || '',
                            webpage_name: stateService.getCurrentName(),
                            parm1: '0',
                            parm2: '0',
                            supplier_no: '0',
                            search_only_this_supplier: '0',
                            businessco_no: '0',
                            onlyonstock: '0',
                            model_id: vm.model.setting.model_id
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            // #region SELECTED VALUE FUNCTION

            vm.onTypeaheadSelected = function (item, id) {
                switch (id) {
                    case 'prod_name':
                        if (item) {
                            vm.model.setting.prod_id = item?.item_id ?? '';
                            vm.model.setting.prod_name = item?.item_name ?? '';

                            rememberFunc('prod_id');
                        } else {
                            vm.onTypeaheadClear('prod_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion SELECTED VALUE FUNCTION

            // #region CHANGED VALUE FUNCTION

            vm.onTypeaheadChanged = function (value, item, id) {
                switch (id) {
                    case 'prod_name':
                        vm.model.setting.prod_name = value;

                        if (value) {
                            if (item?.item_id) {
                                vm.model.setting.prod_id = item.item_id;
                            }
                        } else {
                            vm.onTypeaheadClear('prod_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion CHANGED VALUE FUNCTION

            // #region CLEAR VALUE FUNCTION

            vm.onTypeaheadClear = function (id) {
                switch (id) {
                    case 'prod_name':
                        vm.model.setting.prod_id = '';
                        vm.model.setting.prod_name = '';

                        rememberFunc('prod_id');
                        loadRules();
                        break;
                    default:
                        break;
                }
            };

            // #endregion CLEAR VALUE FUNCTION

            // #region REFRESH BUTTON FUNCTION

            vm.refreshChanges = function () {
                vm.model.refreshing = true;
                loadRules();
            };

            // #endregion REFRESH BUTTON FUNCTION

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'choicepossrule':
                        go({ choicepossrule_keyno: '0' });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region ON CHANGE FUNCTIONS

            vm.onChoiceProductChanged = async function (value) {
                vm.model.setting.choice_prod_id = value;

                if (value) {
                    vm.model.setting.furniturefabrics_id = 'ALL';
                    vm.model.setting.prod_id_choosed = '';

                    rememberFunc('choice_prod_id');
                    loadChosenProducts();
                    await retrieveNumberOfFurnitureFabrics();
                    loadFurnitureFabrics();
                    loadRules();
                };
            }

            vm.onModelChanged = async function (value) {
                vm.model.setting.model_id = value;

                if (value) {
                    rememberFunc('model_id');
                    retrieveNumberOfProducts();
                    loadRules();
                    vm.onTypeaheadClear('prod_name');
                }
            }

            vm.onProductNameSelected = function (value) {
                vm.model.setting.prod_id = value;

                if (value) {
                    let productItem = vm.model.selectListProductNames.find((item) => item?.prod_id === vm.model.setting.prod_id);

                    if (productItem?.prod_name) {
                        vm.model.setting.prod_name = productItem.prod_name;
                        rememberFunc('prod_id');
                    }
                } else {
                    vm.onTypeaheadClear('prod_name');
                }
            }

            vm.onChosenProductChanged = function (value) {
                vm.model.setting.prod_id_choosed = value;

                if (value !== undefined) {
                    rememberFunc('prod_id_choosed');
                    loadRules();
                }
            }

            vm.onFurnitureFabricsChanged = function (value) {
                vm.model.setting.furniturefabrics_id = value;

                if (value) {
                    rememberFunc('furniturefabrics_id');
                    loadChosenProducts();
                    loadRules();

                    if (vm.model.setting.furniturefabrics_id === 'ALL') {
                        vm.model.setting.prod_id_choosed = '';
                        rememberFunc('prod_id_choosed');
                    }
                }
            }

            // #endregion ON CHANGE FUNCTIONS

            // #region LIFE CYCLE FUNCTION

            vm.$onInit = async function () {
                loadProductChoices();
                loadModels();

                vm.model.setting = (await choicePossRulesService.getSetting({
                    argtype: argType,
                    argvalue: argValue
                }))[0];

                await Promise.all([
                    retrieveNumberOfFurnitureFabrics(),
                    loadChosenProducts(),
                    retrieveNumberOfProducts(),
                ]);

                loadFurnitureFabrics();
                loadRules();
            }

            // #endregion LIFE CYCLE FUNCTION

        }]
    });
})();
